import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NmsDialogService } from "@nms-angular-toolkit/nms-dialog";
import { ErrorResponseHandlerService } from "@nms-ng2/app/core/services/error-response-handler/error-response-handler.service";
import { catchError } from "rxjs/operators";
import { Observable, of } from "rxjs";
import {
    DwdmCircuitAmplifierModeTypeData,
    DwdmCircuitAmplifierProfileData,
    DwdmCircuitAmplifierSettingsData
} from "../../amplifiers-step.model";

/**
 * Serviço responsável por retornar os dados dos amplificadores.
 */
@Injectable({
    providedIn: "root"
})
export class ConfigAmplifierService {
    baseUrl = "/web/topology/circuit/dwdm";

    constructor(private readonly http: HttpClient, private readonly errorResponseHandlerService: ErrorResponseHandlerService,
        private readonly nmsDialogService: NmsDialogService) {}

    getAmplifierSettings(profile: DwdmCircuitAmplifierProfileData, mode: DwdmCircuitAmplifierModeTypeData):
            Observable<DwdmCircuitAmplifierSettingsData> {
        return this.http
            .get<DwdmCircuitAmplifierSettingsData>(`${this.baseUrl}/settings/amplifier/${profile}/${mode}`)
            .pipe(catchError((error) => {
                this.handleError(error);
                return of({} as DwdmCircuitAmplifierSettingsData);
            }));
    }

    private handleError(error: HttpErrorResponse): void {
        const { description, details } = this.errorResponseHandlerService.buildErrorDescriptionDetails(error.error);
        this.nmsDialogService.openDialog(
            { description: description + details, acceptLabel: "OK", bindHtml: true },
            { maxWidth: "800px" }
        );
    }
}
